 

<section class="ecb-x-admin-list-section">

  <div class="container-fluid">

    <div class="ecb-x-admin-list-card">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <div>
      <h1 class="ecb-section-title">Admins</h1>
      <p class="ecb-muted mb-0">Add and manage administrator accounts.</p>
    </div>
    <button class="ecb-btn-primary" (click)="openNew()">Add New</button>
  </div>
<p-table
    [value]="pagedUsers"
    responsiveLayout="scroll"
    styleClass="ecb-admin-table">

  <!-- Header -->
  <ng-template pTemplate="header">

    <tr class="ecb-admin-table-header-row">

      <th class="ecb-admin-table-header">
        ID
      </th>

      <th class="ecb-admin-table-header">
        Name
      </th>

      <th class="ecb-admin-table-header">
        Email
      </th>

      <th class="ecb-admin-table-header">
        Active
      </th>

      <th class="ecb-admin-table-header ecb-admin-table-action-header">
        Action
      </th>

    </tr>

  </ng-template>


  <!-- Body -->
  <ng-template pTemplate="body" let-row>

    <tr class="ecb-admin-table-row">

      <!-- ID -->
      <td class="ecb-admin-table-cell">
        {{ row.userId }}
      </td>

      <!-- Name -->
      <td class="ecb-admin-table-cell">
        {{ row.fullName }}
      </td>

      <!-- Email -->
      <td class="ecb-admin-table-cell">
        {{ row.email }}
      </td>

      <!-- Active -->
      <td class="ecb-admin-table-cell">

        <span
          class="ecb-admin-user-status"
          [class.ecb-admin-user-status-active]="row.isActive"
          [class.ecb-admin-user-status-inactive]="!row.isActive">

          {{ row.isActive ? 'Active' : 'Inactive' }}

        </span>

      </td>

      <!-- Action -->
      <td class="ecb-admin-table-cell ecb-admin-table-action-cell">

        <button
          type="button"
          class="ecb-admin-table-action-button ecb-admin-table-edit-button"
          (click)="edit(row)"
          title="Edit user"
          [attr.aria-label]="'Edit ' + row.fullName">

        <i class="bi bi-pencil-square ecb-admin-table-action-icon"></i>
        </button>

      </td>

    </tr>

  </ng-template>


  <!-- Empty -->
  <ng-template pTemplate="emptymessage">

    <tr class="ecb-admin-table-row">

      <td
        colspan="5"
        class="ecb-admin-table-cell text-center py-4">

        No users found.

      </td>

    </tr>

  </ng-template>

</p-table>

  <p-dialog [(visible)]="showDialog" [modal]="true" [style]="{width:'560px'}" header="Admins">
    <div class="row g-3">
      <div class="col-md-6" *ngFor="let field of editorFields">
        <label>{{ field.label }}</label>
        <input class="ecb-form-control" [(ngModel)]="editor[field.name]"
          [disabled]="(field.name === 'userId' || field.name === 'email')?true:false">
      </div>
    </div>
    <ng-template pTemplate="footer"><button class="ecb-btn-outline" (click)="showDialog=false">Cancel</button><button
        class="ecb-btn-primary" (click)="save()">Save</button></ng-template>
  </p-dialog>

</div>
</div>
</section>